import * as angular from "angular";

export class SurveyService {
    private apiRoot: string;
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/survey";
        this.v2Root = "/v2/survey";
    }

    info(id: any, params?: any): Promise<object> {
        return params
            ? this.$http.get(this.v2Root + "/info/" + id, { params: params })
            : this.$http.get(this.v2Root + "/info/" + id);
    }

    all(params?: any): Promise<object> {
        return params
            ? this.$http.get(this.v2Root + "/all", { params: params })
            : this.$http.get(this.v2Root + "/all");
    }

    formats(): Promise<object> {
        return this.$http.get(this.v2Root + "/formats");
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/create", data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/update/" + data.sid, data);
    }

    updateOrder(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/updateOrder", data);
    }

    updateQuestionOrder(surveyId: number, data: any): Promise<object> {
        return this.$http.post(
            this.v2Root + "/updateQuestionOrder/" + surveyId,
            data
        );
    }

    delete(surveyId: string | number): Promise<object> {
        return this.$http.delete(this.v2Root + "/delete/" + surveyId);
    }

    deleteAnswers(canvassId: string | number): Promise<object> {
        return this.$http.delete(this.v2Root + "/answers/" + canvassId);
    }

    importNationBuilder(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/importnationbuilder", data);
    }
}

angular.module("vcServices").service("SurveyService", SurveyService);
